<template>
  <div class="headerBox">
    <van-icon @click="onShow" style="width: 24px;height:24px;" name="wap-nav" color="#fff" />
    <popup
      v-model:show="isShow"
      position="left"
      style="height: 100%; width: 60%"
    >
      <div class="popup">
        <div @click="onJump('/')">首页</div>
        <div @click="onJump('/addCase')">填报工时</div>
        <div @click="onJump('/stayCase')">待提报事项</div>
        <div @click="onJump('/caseList')">案件列表</div>
        <div @click="onJump('/myCase')">个人统计</div>
      </div>
    </popup>
  </div>
  <div class="all-body">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Button, Icon, Popup } from 'vant';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    Popup,
  },
  setup() {
    const router = useRouter();
    const isShow = ref(false);
    const onShow = () => {
      isShow.value = !isShow.value;
    };
    const onJump = (url: string) => {
      isShow.value = false;
      router.push({ path: url });
    };
    return {
      isShow,
      onShow,
      onJump,
    };
  },
});
</script>

<style lang="scss" scoped>
.all-body {
  margin-top: 50px;
}
.headerBox {
  top: 0;
  position: fixed;
  width: 100%;
  z-index: 99;
  background: #5374e8;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  .popup {
    height: 100%;
    background: #5374e8;
    color: #fff;
    padding: 50px 0 0 20px;
    box-sizing: border-box;
    div {
      font-size: 18px;
      font-weight: bold;
      padding: 15px 0;
      color: #fff;
      display: block;
    }
  }
}
</style>
